module.exports = __webpack_public_path__ + "img/om_qr_douyin.3f4b557a.png";